import { useEffect, useRef } from 'react';
import { useAriaLive } from '@ally/use-aria-live';
import { haveOptionsChanged } from '../utils';
import { useDebounce } from '../../../../tools/utils';
import { visual, a11y } from '../../../strings';
export const useAnnouncements = ({ inputValue, minSearchChars, filteredOptions, showOptions, isLoading, getAriaLiveResults = a11y.getAriaLiveResults, noResultsText = visual.noResults, }) => {
    const staticPrevFilteredOptions = useRef([]);
    const { announcePolite } = useAriaLive();
    // giving the announcements additional time so that it doesn't queue
    // its announcement until after the ui changes are queued by the SR
    const { handleValueChange: debounceAriaLive } = useDebounce({
        debounceTimeout: 500,
        onDebounced: announcePolite,
        cancelDebounce: () => inputValue.length < minSearchChars || (!showOptions && !isLoading),
    });
    const announcementText = !filteredOptions.length
        ? noResultsText
        : getAriaLiveResults(filteredOptions.length);
    useEffect(() => {
        if (haveOptionsChanged(staticPrevFilteredOptions.current, filteredOptions)) {
            debounceAriaLive(announcementText);
            staticPrevFilteredOptions.current = filteredOptions.slice();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredOptions]);
};
//# sourceMappingURL=useAnnouncements.js.map